import React from 'react'
import {
  amtNumStr,
  amtStr,
} from '@ifca-root/react-component/src/helpers/StringNumberFunction/numFormatter'
import { formatDate } from 'helpers/StringNumberFunction/FormatDate'

export const ReversePredevalueDetailContent = ({ listEl }) => {
  return (
    <>
      <div className="content-wrap left">
        <div className="desc" style={{ color: 'grey' }}>
          Date
        </div>
        <div className="mdDesc text-noflow">
          {formatDate(listEl?.reversal_date)}
        </div>
      </div>
      <div className="content-wrap right">
        <div className="desc" style={{ color: 'grey' }}>
          Reversal Amount
        </div>
        <div className="mdDesc text-noflow">
          {amtStr(listEl?.reversal_amount)}
        </div>
      </div>
      <div className="content-wrap full">
        <div className="desc" style={{ color: 'grey' }}>
          Accumulated Impairment Reversal
        </div>
        <div className="mdDesc text-noflow">
          {amtStr(listEl?.accumulated_impairment_reversal)}
        </div>
      </div>
      <div className="content-wrap full">
        <div className="desc" style={{ color: 'grey' }}>
          Description
        </div>
        <div className="mdDesc text-noflow">{listEl?.description}</div>
      </div>
      <div className="content-wrap full">
        <div className="desc" style={{ color: 'grey' }}>
          Reason
        </div>
        <div className="mdDesc text-noflow">{listEl?.reason}</div>
      </div>
    </>
  )
}
